$(document).ready(function(){
    $("body").on({
        mouseenter: function () {
            $(this).find('.buy-button .btn').addClass("hover");
            $(this).find('.buy-button a').addClass("hover");
            $(this).find('a.location-link').addClass("hover");
        },
        mouseleave: function () {
            $(this).find('.buy-button .btn').removeClass("hover");
            $(this).find('.buy-button a').removeClass("hover");
            $(this).find('a.location-link').removeClass("hover");
        }
    },'.events .item');
    //==========================================================================
    // buttons
    //==========================================================================
    /*
    $(".btn").each(function() {
        var nodeName = this.nodeName;
        if (nodeName == 'A' || nodeName == 'BUTTON') {
            var text = $( this ).html();
            $( this ).html('<span>' + text + '</span>');
        }

        if (nodeName == 'INPUT') {
            text = $( this ).attr('value');
            $( this ).parent().html('<span>' + text + '</span>');
        }
    });
    */
    $('input[type="checkbox"]').simpleButtonChecks({
        checkedIcon : '<i class="fa fa-check-square-o fa-18"></i>',
        nonCheckedIcon : '<i class="fa fa-square-o fa-18"></i>',
        onInit: function(simpleButtonChecks){
            $(simpleButtonChecks.$element).closest('label').css('color', (simpleButtonChecks.isChecked ? '#333' : '#a9a9a9'));
        },
        changeCallback: function(simpleButtonChecks){
            $(simpleButtonChecks.$element).closest('label').css('color', (simpleButtonChecks.isChecked ? '#333' : '#a9a9a9'));
        },
    });
    //$('input[type="radio"]').simpleButtonRadios({
    //    checkedIcon : '<i class="fa fa-circle"></i>',
    //});

    $('a.popup').click(function(event) {
        event.preventDefault();
        window.open($(this).attr("href"), "popupWindow", "width=600,height=600,scrollbars=yes");
    });

    //????????? untested
    /*
    $('#main-menu li.dropdown').click(function(){
        if(!$(this).hasClass('disabled')){
            $(this).find('.dropdown-menu').stop(true, true).delay(100).toggle();
        }
    });

    //top menu opening on hover
    $('#main-menu li.dropdown').hover(function() {
        if(!$(this).hasClass('disabled')){
            $(this).find('.dropdown-menu').stop(true, true).delay(100).fadeIn(200);
            if(!$(this).parent().hasClass('disabled')) {
                $('.dropdown').removeClass('open');
                $('#datepicker').data("DateTimePicker").show();
            }
        }
    }, function() {
        if(!$(this).hasClass('disabled')){
            $(this).find('.dropdown-menu').stop(true, true).delay(100).fadeOut(400);
        }
    });
    */
    //==========================================================================
    // scroll text
    //==========================================================================
    var scroll_text;
	var start_shift;
    var scrollText = function($elmt) {
        if ($elmt.find('div.scrolled-title .scrolled-text').length) {
            var left = $elmt.find('div.scrolled-title .scrolled-text').position().left - 1 - start_shift;
            left = -left > $elmt.find('div.scrolled-title .scrolled-text').width() ? $elmt.find('div.scrolled-title').width() : left;
            $elmt.find('div.scrolled-title .scrolled-text').css({
                left: left
            });
        }
    };
    $("body").on({
        mouseenter: function () {
            var $elmt = $(this);
            position = $(this).find('div.scrolled-title .scrolled-text').position();
            if(typeof position === 'undefined'){
                return;
            }
            start_shift = position.left;
            if ($elmt.find('div.scrolled-title .scrolled-text').width() > $elmt.find('div.scrolled-title').width()) {
                scroll_text = setInterval(function(){
                    scrollText($elmt);
                }, 42);
            }
        },
        mouseleave: function () {
            clearInterval(scroll_text);
            $(this).find('div.scrolled-title .scrolled-text').css({
                left: 0
            });
        }
    },'div.item');

    var scroll_text2;
	var start_shift2;
    var scrollText2 = function($elmt) {
        /*if ($elmt.find('div.scrolled-title2 .scrolled-text2').length) {
            var left = $elmt.find('div.scrolled-title2 .scrolled-text2').position().left - 1;
            left = -left > $elmt.find('div.scrolled-title2 .scrolled-text2').width() ? $elmt.find('div.scrolled-title2').width() : left;
            $elmt.find('div.scrolled-title2 .scrolled-text2').css({
                left: left
            });
        }*/
        var copo = $elmt.find('div.scrolled-title2 .scrolled-text2');

        if (copo.length) {
            var left = copo.position().left - 1 - start_shift2;
            left = -left > copo.width() ? $elmt.find('div.scrolled-title2').width() : left;

            copo.css({
                left: left
            });
        }
    };

    $("body").on({
        mouseenter: function () {
            var $elmt = $(this);
            position = $(this).find('div.scrolled-title2 .scrolled-text2').position();
            if(typeof position === 'undefined'){
                return;
            }
			start_shift2 = position.left;
            if ($elmt.find('div.scrolled-title2 .scrolled-text2').width() + 25 > $elmt.find('div.scrolled-title2').width()) {
                scroll_text2 = setInterval(function(){
                    scrollText2($elmt);
                }, 42);
            }
        },
        mouseleave: function () {
            clearInterval(scroll_text2);
            $(this).find('div.scrolled-title2 .scrolled-text2').css({
                left: 0
            });
        }
    },'div.item');

    function animateTrimedText(el, duration) {
        var animationDuration = duration || 500;
        var el = $(el);
        var isTrimed = el.hasClass('trim');

        if (isTrimed) {
            var trimedHeight = el.height();
            el.removeClass('trim');

            var fullHeight = el.height();
            el.height(trimedHeight);

            el.animate(
                {
                    height: fullHeight + 'px',
                },
                animationDuration,
                function () {
                    el.css({ height: '' });
                }
            );
        }
        else {
            el.addClass('trim');
            var trimedHeight = el.height();
            el.removeClass('trim');

            el.animate(
                {
                    height: trimedHeight + 'px',
                },
                animationDuration,
                function () {
                    el.css({ height: '' });
                    el.addClass('trim');
                }
            );
        }
    }

    $('.expand-trim').on('click', function() {
        var el = $(this);
        var trimDisableThen = el.data('trim-disable-then');

        if (trimDisableThen && window.matchMedia(trimDisableThen).matches) {
            return;
        }

        var parentSelector = el.data('parent');
        var buttonSelector = el.data('triger-button');

        if (parentSelector && buttonSelector) {
            var button = el.closest(parentSelector).find(buttonSelector);
            var trimedText = button.closest(parentSelector).find('.expand-trim');
            var icon = button.find('.expand-arrow');
            var trimed = trimedText.hasClass('trim');

            if (trimed) {
                icon.css({ transform: 'rotate(180deg)' });
            } else {
                icon.css({ transform: 'rotate(0deg)' });
            }
        }

        animateTrimedText(this);
    });

    $('.expand-btn').on('click', function() {
        var el = $(this);
        var trimDisableThen = el.data('trim-disable-then');

        if (trimDisableThen && window.matchMedia(trimDisableThen).matches) {
            return;
        }

        var button = $(this);
        var icon = button.find('.expand-arrow');

        var parentSelector = button.data('parent');
        var targetSelector = button.data('target');

        if (!parentSelector || !targetSelector) {
            return;
        }

        var trimedText = button.closest(parentSelector).find(targetSelector);

        if (trimedText.length > 0) {
            var trimed = trimedText.hasClass('trim');

            if (trimed) {
                icon.css({ transform: 'rotate(180deg)' });
            } else {
                icon.css({ transform: 'rotate(0deg)' });
            }

            animateTrimedText(trimedText);
        }
    });
});
